import "./work-hyundai.css";
import OurWorksSection from "../../../components/our-works-section/OurWorksSection";

function WorkHyundai() {
  const id = 4

  return (
    <div className="work hyundai">
      {/* Work Header */}
      <div className="work-header">
        <div className="work-branding">
          <div className="work-branding-title">
            <div className="work-branding-title-col-1">
              {window.innerWidth <= 768 ?
                <img
                  src="/assets/icons/partner-companies-logos/hyundai.svg"
                  alt="Hyundai Logo"
                /> :
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF5611" }}
                >
                  <span>HYUNDAI - </span> Automobile Modification
                </h2>
              }
              {window.innerWidth <= 768 ?
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF5611" }}
                >
                  <span>HYUNDAI - </span> Automobile Modification
                </h2>
                :
                <button
                  onClick={() => window.open("https://www.behance.net/gallery/120429025/UXUI-WEB-DESIGN-HYUNDAI-AUTO-GEORGIA", "_blank")}
                >
                  Discover
                  &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                    <g clipPath="url(#clip0_272_603)">
                      <path
                        d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_272_603">
                        <rect width={12} height={12} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              }
            </div>
            <div
              className={`work-branding-title-col-2  ${window.innerWidth <= 768 ? "d-none" : ""
                }`}
            >
              <img
                src="/assets/icons/partner-companies-logos/hyundai.svg"
                alt="Hyundai Logo"
              />
            </div>
          </div>
          <h1
            className={`animate__animated animate__fadeIn animate__slow ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
          >
            World class eco-friendly technologies in preparation for the shift to electrified vehicles.
          </h1>
        </div>

        <img
          src="/assets/images/work-pages/hyundai/hyundai-1.webp"
          alt="Work Image"
        />

        <h1 className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          World class eco-friendly technologies in preparation for the shift to electrified vehicles.
        </h1>

        <button
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          onClick={() => window.open("https://www.behance.net/gallery/120429025/UXUI-WEB-DESIGN-HYUNDAI-AUTO-GEORGIA", "_blank")}
        >
          Discover
          &nbsp;
          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
            <g clipPath="url(#clip0_272_603)">
              <path
                d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_272_603">
                <rect width={12} height={12} fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      {/* Work Desc Section */}
      <div className="work-desc-section">
        <div className="work-desc">
          <p>
            HYUNDAI motor company has served as the trailblazer of korea's automobile industry since rolling out its pony, developed with its own exclusive technology.
          </p>
          <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`} >
            HYUNDAI motor co. (hmc), established in 1967, is the auto sales leader in the korean domestic market and exports vehicles to 190 countries worldwide. hyundai motor co. operates the world's largest integrated automobile manufacturing facility in ulsan, located on korea's southeast coast.
          </p>
        </div>
        <div
          className={`work-provided-services ${window.innerWidth <= 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>Prototype</li>
            <li>UI/UX Design</li>
            <li>Web Design</li>
            <li>Responsive Design</li>
          </ul>
        </div>
      </div>

      {/* Work Section 1 */}
      <div className="work-section-1">
        <h1 className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>ADVANCED SHIF OF SUNSTABILITY</h1>
        <img
          src="/assets/images/work-pages/hyundai/hyundai-2.webp"
          alt="Work Image"
        />

        <div
          className={`work-provided-services ${window.innerWidth > 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>Prototype</li>
            <li>UI/UX Design</li>
            <li>Web Design</li>
            <li>Responsive Design</li>
          </ul>
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`} >
          HYUNDAI motor co. (hmc), established in 1967, is the auto sales leader in the korean domestic market and exports vehicles to 190 countries worldwide. hyundai motor co. operates the world's largest integrated automobile manufacturing facility in ulsan, located on korea's southeast coast.
        </p>
      </div>

      {/* Work Section 2 */}
      <div className="work-section-2">
        <h1>Explore Hyundai's 3D Car Configurator.</h1>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Car modifications include a wide range of alterations that can enhance your vehicle's look and performance. Visual Enhancements: Custom paint, aftermarket wheels, body kits, and spoilers enhance the car's appearance and uniqueness
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Expensive. Modifying your car can be expensive, especially if you do a lot of the work yourself. You might have to buy new parts, pay for a custom paint job, or get your car tuned up by a professional. All of this can add up quickly, and it's easy to spend several thousand dollars on modifications.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          On automatic vehicles, it usually requires pressing a button on the shift lever and pulling it backward until it is aligned with the letter “r.” In standard vehicles equipped with a five speed transmission, you can usually shift into reverse by pressing the shift lever all the way to the left and pulling it backward.
        </p>
        <img
          src="/assets/images/work-pages/hyundai/hyundai-3.webp"
          alt="Work Image"
        />
        <div className="d-flex justify-content-center">
          <img
            src="/assets/images/work-pages/hyundai/hyundai-4.webp"
            alt="Work Image"
          />
          <img
            src="/assets/images/work-pages/hyundai/hyundai-5.webp"
            alt="Work Image"
          />
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Car modifications include a wide range of alterations that can enhance your vehicle's look and performance. Visual Enhancements: Custom paint, aftermarket wheels, body kits, and spoilers enhance the car's appearance and uniqueness
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Expensive. Modifying your car can be expensive, especially if you do a lot of the work yourself. You might have to buy new parts, pay for a custom paint job, or get your car tuned up by a professional. All of this can add up quickly, and it's easy to spend several thousand dollars on modifications.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          On automatic vehicles, it usually requires pressing a button on the shift lever and pulling it backward until it is aligned with the letter “r.” In standard vehicles equipped with a five speed transmission, you can usually shift into reverse by pressing the shift lever all the way to the left and pulling it backward.
        </p>
      </div>

      {/* Work Section 3 */}
      <div className="work-section-3">
        <h1>The Results</h1>
        <img
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/hyundai/hyundai-6.webp"
          alt="Work Image"
        />
        <p>
          Generally, game mods are legal if they do not infringe on a product's
          copyrights. However, they can be illegal depending on the game studio
          and country laws. Studios can allow fan-generated content, while
          others treat it as an infringement of the legal rights of the
          copyright owner.
        </p>
        <h2>
          Financial savings, because engine swapping is usually less expensive
          than buying a new vehicle
        </h2>
        <img
          className={`${window.innerWidth <= 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/hyundai/hyundai-6.webp"
          alt="Work Image"
        />
      </div>

      <OurWorksSection workPageId={id} />
    </div>
  );
}

export default WorkHyundai;
